<div class="chipListContainer">
    @if (filterParams?.tags != null || filterParams?.tags != []) {
        <div class="mainFilter">
            <!-- SearchBar -->
            @if (!isSearchingMobile) {
                <mat-form-field class="searchBar" appearance="outline" (click)="focusMobile()">
                    <mat-icon color="primary" matPrefix>search</mat-icon>
                    <input
                        matInput
                        [placeholder]="isDeviceIsdesktop ? 'Rechercher un écran, une ville' : 'Rechercher'"
                        [formControl]="searchQuery"
                        (keyup.enter)="onSearch()"
                    />
                    <mat-icon
                        [style.display]="
                            searchQuery.value != null && searchQuery.value === initSearch && isDeviceIsdesktop
                                ? 'block'
                                : 'none'
                        "
                        color="primary"
                        style="cursor: pointer; margin-right: 10px"
                        matSuffix
                        (click)="searchQuery.setValue(null); onSearch()"
                        matSuffix
                    >
                        clear
                    </mat-icon>
                </mat-form-field>
            }
            <button
                class="filterBtn"
                matBadge=" 1"
                [matBadgeHidden]="filterParams.tags?.length <= 0 && filterParams.faceIds?.length <= 0"
                matBadgeOverlap="true"
                (click)="openFilterCategoryDialog()"
                mat-flat-button
                color="primary"
            >
                Filtrer <mat-icon iconPositionEnd>filter_list</mat-icon>
            </button>
        </div>

        @if (filterParams.tags?.length > 0 || filterParams.faceIds?.length > 0) {
            <div class="filterDetail">
                <mat-chip-listbox class="chipList" aria-label="Tags selected">
                    <!-- Tags -->
                    @for (tagId of filterParams.tags; track $index) {
                        <mat-chip-option matTooltip="Supprimer le tag" (click)="removeTag(tagId)">
                            {{ getTagName(tagId) }}
                            <button matChipRemove (click)="removeTag(tagId)">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </mat-chip-option>
                    }
                    <!-- Tags / Face -->
                    @for (tagId of filterParams.faceIds; track $index) {
                        <mat-chip-option matTooltip="Supprimer le tag" (click)="removeTag(tagId)">
                            {{ getTagName(tagId) }}
                            <button matChipRemove (click)="removeTag(tagId)">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
                <!-- Bouton "Tout effacer" -->
                <button class="clearTagBtn" mat-button color="primary" (click)="clearAllFilter()">Tout effacer</button>
            </div>
        }
    }
</div>

@if (isSearchingMobile) {
    <div class="searchMobileContainer">
        <div class="inputContainer">
            <!-- SearchBar -->
            <mat-form-field class="searchBar" appearance="outline" (click)="focusMobile()">
                <mat-icon (click)="hideSearchMobile()" color="primary" matPrefix>west</mat-icon>
                <input
                    #mobileSearchBar
                    matInput
                    placeholder="Rechercher un écran, une ville"
                    [formControl]="searchQuery"
                    (keyup.enter)="onSearch()"
                />
                <mat-icon
                    [style.display]="
                        searchQuery.value != null
                            ? 'block'
                            : 'none'
                    "
                    color="primary"
                    style="cursor: pointer; margin-right: 10px"
                    matSuffix
                    (click)="searchQuery.setValue(null); onSearch()"
                    matSuffix
                >
                    clear
                </mat-icon>
            </mat-form-field>

            @if (searchQuery.value != null && searchQuery.value != '') {
                <button class="searchBtn" mat-flat-button color="primary" (click)="onSearch()">
                    <mat-icon>search</mat-icon>Rechercher
                </button>
            }
        </div>

        <div (click)="hideSearchMobile()" id="filterOpacitor" class="opacitor"></div>
    </div>
}

<!-- MARK: Paneau de filtrage pour mobile -->
@if (!isDeviceIsdesktop) {
    <app-filter-category-dialog
        [displayMobileFilterPanel]="displayMobileFilterPanel"
        [isMobile]="true"
        (groupByChanged)="groupBy($event)"
        (filterChanged)="filterChanged($event)"
        [groupedBy]="this.filterParams?.groupById"
    ></app-filter-category-dialog>
}
